import { Appointments } from "features/schedule/appointments";
import { Route } from "react-router-dom";

export const AppointmentsRoutes = (
  <Route path="appointments" element={<Appointments />}></Route>
);
